import { USER_NAME_CHECK_RESULT, USER_NAME_CHECK_ERROR } from '../actions/action-types';

const userNameCheckReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_NAME_CHECK_RESULT:
      return {
        ...state,
        error: false,
      };
    case USER_NAME_CHECK_ERROR:
      return {
        ...state,
        error: true,
      };
    default:
      return state;
  }
};

export default userNameCheckReducer;
